/**
 * BHADKO OTT - Complete Localization Dictionary
 * Default language: Gujarati (gu)
 * Supported languages: Gujarati (gu), Hindi (hi), English (en)
 */

export const TRANSLATIONS = {
  gu: {
    // Brand & Header
    brandTitle: "ભડકો OTT",
    brandSubtitle: "BHADKO DIGITAL TV MEDIA",
    navHome: "હોમ",
    navAllChannels: "બધા ચેનલ",
    navLiveTV: "લાઇવ ટીવી",
    navFavorites: "મનપસંદ",
    navCategories: "શ્રેણીઓ",
    navAdmin: "ચેનલ સંચાલન",
    navTvMode: "ટીવી મોડ",
    searchPlaceholder: "ચેનલ અથવા શ્રેણી શોધો...",
    searchChannelsPlaceholder: "ચેનલ શોધો...",

    // Discovery / Grid View
    allChannelsTitle: "બધા ચેનલ | All Channels",
    allChannelsSubtitle: "૫૦+ થી વધુ લાઈવ ટેલિવિઝન ચેનલો વિવિધ શ્રેણીઓમાં માણો.",
    allLanguages: "બધી ભાષાઓ",
    sortLatest: "નવીનતમ",
    sortPopular: "સૌથી વધુ જોવાયેલ",
    sortAlphabetical: "નામ પ્રમાણે (A-Z)",
    watchLive: "લાઇવ જુઓ",
    startingSoon: "ટૂંક સમયમાં",
    offline: "ઓફલાઇન",
    liveBadge: "લાઇવ",
    loadMore: "વધુ ચેનલો દર્શાવો",
    noChannelsFound: "કોઈ ચેનલ મળી નથી",
    noChannelsSubtitle: "કૃપા કરીને અન્ય શબ્દ અથવા ફિલ્ટર વડે ફરી પ્રયાસ કરો.",
    resetFilters: "ફિલ્ટર રીસેટ કરો",

    // Player Page
    watchingCount: "દર્શકો જોઈ રહ્યા છે",
    verified: "પ્રમાણિત",
    share: "શેર કરો",
    shareSuccess: "ચેનલ લિંક કૉપિ થઈ ગઈ છે!",
    addToFavorites: "મનપસંદમાં ઉમેરો",
    removeFromFavorites: "મનપસંદમાંથી હટાવો",
    tabAbout: "વિગત",
    tabSchedule: "કાર્યક્રમ સમયપત્રક",
    tabRelated: "સંબંધિત ચેનલો",
    nowPlaying: "હાલમાં પ્રસારિત",
    upcoming: "આગામી કાર્યક્રમ",
    studio: "સ્ટુડિયો",
    network: "નેટવર્ક",
    resolution: "રિઝોલ્યુશન",
    bitrate: "બિટરેટ",
    audio: "ઓડિયો",
    editorialChief: "મુખ્ય સંપાદક",
    streamUnavailable: "સ્ટ્રીમ ઉપલબ્ધ નથી",
    streamUnavailableDesc: "આ ચેનલનું લાઈવ પ્રસારણ હાલમાં અસ્થાયી રૂપે સ્થગિત છે અથવા કનેક્શન સમસ્યા છે.",
    loadingStream: "લોડ થઈ રહ્યું છે...",
    retryButton: "ફરી પ્રયાસ કરો",
    channelSidebarTitle: "બધા ચેનલ",
    filterBtn: "ફિલ્ટર",
    switchChannelPrompt: "ચેનલ બદલવા માટે ક્લિક કરો",
    qualityAuto: "ઓટો (Auto)",

    // Favorites View
    favoritesTitle: "તમારી મનપસંદ ચેનલો",
    favoritesSubtitle: "તમે સાચવેલી તમામ લાઈવ ટીવી ચેનલો અહીં સરળતાથી જુઓ.",
    noFavoritesTitle: "કોઈ મનપસંદ ચેનલ ઉમેરેલી નથી",
    noFavoritesDesc: "ચેનલ કાર્ડ પરના સ્ટાર (★) બટન પર ક્લિક કરીને તમારી મનપસંદ ચેનલ અહીં ઉમેરો.",
    browseChannelsBtn: "ચેનલો શોધો",

    // TV Mode
    tvModeActive: "ટીવી રિમોટ મોડ સક્રિય છે",
    tvModeHint: "નેવિગેટ કરવા માટે કીબોર્ડ એરો કી (↑ ↓ ← →) અને સિલેક્ટ કરવા માટે 'Enter / OK' દબાવો.",
    tvExitHint: "સામાન્ય મોડમાં પાછા જવા માટે 'TV Mode' પર ફરી ક્લિક કરો અથવા Escape દબાવો.",

    // Admin Dashboard
    adminTitle: "BHADKO OTT - ચેનલ વ્યવસ્થાપક",
    adminSubtitle: "નવી ચેનલ ઉમેરો, માહિતી સંપાદિત કરો, ક્રમ બદલો અને સ્ટ્રીમ સેટિંગ્સ સંચાલિત કરો.",
    btnAddNewChannel: "+ નવી ચેનલ ઉમેરો",
    colLogo: "લોગો",
    colName: "ચેનલ નામ",
    colCategory: "શ્રેણી",
    colLanguage: "ભાષા",
    colStatus: "સ્થિતિ",
    colStream: "સ્ટ્રીમ URL",
    colActions: "ક્રિયાઓ",
    activeStatus: "સક્રિય",
    inactiveStatus: "નિષ્ક્રિય",
    btnEdit: "સંપાદિત કરો",
    btnDelete: "કાઢી નાખો",
    btnPreview: "પ્રિવ્યૂ",
    btnSave: "સાચવો",
    btnCancel: "રદ કરો",
    modalAddTitle: "નવી ચેનલ ઉમેરો",
    modalEditTitle: "ચેનલ માહિતી સંપાદિત કરો",
    confirmDeleteTitle: "ચેનલ કાઢી નાખવાની ખાતરી કરો",
    confirmDeleteDesc: "શું તમે ખરેખર આ ચેનલને કેટાલોગમાંથી કાયમ માટે હટાવવા માંગો છો?",
    fieldChannelName: "ચેનલનું નામ (English)",
    fieldGujaratiName: "ગુજરાતી નામ",
    fieldCategory: "શ્રેણી",
    fieldLanguage: "પ્રસારણ ભાષા",
    fieldStreamUrl: "HLS સ્ટ્રીમ URL (.m3u8)",
    fieldDescription: "ટૂંકી વિગત",
    fieldOrder: "ડિસ્પ્લે ક્રમ",
    fieldStatus: "પ્રસારણ સ્થિતિ",
    fieldFeatured: "ફીચર્ડ ચેનલ તરીકે દર્શાવો",
    saveSuccessMsg: "ચેનલ સફળતાપૂર્વક સાચવવામાં આવી!",
    deleteSuccessMsg: "ચેનલ સફળતાપૂર્વક હટાવી દેવામાં આવી!",

    // Footer
    footerDesc: "BHADKO DIGITAL TV MEDIA વિશ્વભરના દર્શકો માટે પ્રીમિયમ ગુજરાતી મનોરંજન, સમાચાર અને લાઈવ ટેલિવિઝન પહોંચાડે છે.",
    footerExplore: "શોધો",
    footerSupport: "સહાયતા",
    helpCenter: "હેલ્પ સેન્ટર",
    terms: "શરતો અને નિયમો",
    privacy: "પ્રાઈવસી પોલિસી",
    contactUs: "સંપર્ક કરો",
    copyright: "© 2026 BHADKO DIGITAL TV MEDIA. સર્વાધિકાર સુરક્ષિત. powered by Earthin.online/"
  },

  hi: {
    brandTitle: "भड़को OTT",
    brandSubtitle: "BHADKO DIGITAL TV MEDIA",
    navHome: "होम",
    navAllChannels: "सभी चैनल",
    navLiveTV: "लाइव टीवी",
    navFavorites: "पसंदीदा",
    navCategories: "श्रेणियाँ",
    navAdmin: "चैनल प्रबंधन",
    navTvMode: "टीवी मोड",
    searchPlaceholder: "चैनल या श्रेणी खोजें...",
    searchChannelsPlaceholder: "चैनल खोजें...",

    allChannelsTitle: "सभी चैनल | All Channels",
    allChannelsSubtitle: "50+ से अधिक लाइव टेलीविज़न चैनलों का विभिन्न श्रेणियों में आनंद लें।",
    allLanguages: "सभी भाषाएँ",
    sortLatest: "नवीनतम",
    sortPopular: "सर्वाधिक देखे गए",
    sortAlphabetical: "नाम अनुसार (A-Z)",
    watchLive: "लाइव देखें",
    startingSoon: "शीघ्र प्रारंभ",
    offline: "ऑफ़लाइन",
    liveBadge: "लाइव",
    loadMore: "और चैनल देखें",
    noChannelsFound: "कोई चैनल नहीं मिला",
    noChannelsSubtitle: "कृपया किसी अन्य शब्द या फ़िल्टर से पुनः प्रयास करें।",
    resetFilters: "फ़िल्टर रीसेट करें",

    watchingCount: "दर्शक देख रहे हैं",
    verified: "प्रमाणित",
    share: "साझा करें",
    shareSuccess: "चैनल लिंक कॉपी हो गया है!",
    addToFavorites: "पसंदीदा में जोड़ें",
    removeFromFavorites: "पसंदीदा से हटाएं",
    tabAbout: "विवरण",
    tabSchedule: "कार्यक्रम अनुसूची",
    tabRelated: "संबंधित चैनल",
    nowPlaying: "अभी प्रसारित",
    upcoming: "आगामी कार्यक्रम",
    studio: "स्टूडियो",
    network: "नेटवर्क",
    resolution: "रिज़ॉल्यूशन",
    bitrate: "बिटरेट",
    audio: "ऑडियो",
    editorialChief: "प्रधान संपादक",
    streamUnavailable: "स्ट्रीम उपलब्ध नहीं है",
    streamUnavailableDesc: "इस चैनल का लाइव प्रसारण वर्तमान में अस्थायी रूप से अनुपलब्ध है।",
    loadingStream: "लोड हो रहा है...",
    retryButton: "पुनः प्रयास करें",
    channelSidebarTitle: "सभी चैनल",
    filterBtn: "फ़िल्टर",
    switchChannelPrompt: "चैनल बदलने के लिए क्लिक करें",
    qualityAuto: "ऑटो (Auto)",

    favoritesTitle: "आपके पसंदीदा चैनल",
    favoritesSubtitle: "आपके द्वारा सहेजे गए सभी लाइव टीवी चैनल यहाँ देखें।",
    noFavoritesTitle: "कोई पसंदीदा चैनल नहीं जोड़ा गया",
    noFavoritesDesc: "चैनल कार्ड पर स्टार (★) बटन पर क्लिक करके अपने पसंदीदा चैनल यहाँ जोड़ें।",
    browseChannelsBtn: "चैनल खोजें",

    tvModeActive: "टीवी रिमोट मोड सक्रिय है",
    tvModeHint: "नेविगेट करने के लिए कीबोर्ड एरो की (↑ ↓ ← →) और चुनने के लिए 'Enter / OK' दबाएँ।",
    tvExitHint: "सामान्य मोड में लौटने के लिए 'TV Mode' पर दोबारा क्लिक करें या Escape दबाएँ।",

    adminTitle: "BHADKO OTT - चैनल प्रबंधक",
    adminSubtitle: "नया चैनल जोड़ें, जानकारी संपादित करें, क्रम बदलें और स्ट्रीम सेटिंग्स प्रबंधित करें।",
    btnAddNewChannel: "+ नया चैनल जोड़ें",
    colLogo: "लोगो",
    colName: "चैनल नाम",
    colCategory: "श्रेणी",
    colLanguage: "भाषा",
    colStatus: "स्थिति",
    colStream: "स्ट्रीम URL",
    colActions: "कार्रवाई",
    activeStatus: "सक्रिय",
    inactiveStatus: "निष्क्रिय",
    btnEdit: "संपादित करें",
    btnDelete: "हटाएं",
    btnPreview: "पूर्वावलोकन",
    btnSave: "सहेजें",
    btnCancel: "रद्द करें",
    modalAddTitle: "नया चैनल जोड़ें",
    modalEditTitle: "चैनल जानकारी संपादित करें",
    confirmDeleteTitle: "चैनल हटाने की पुष्टि करें",
    confirmDeleteDesc: "क्या आप वाकई इस चैनल को सूची से हमेशा के लिए हटाना चाहते हैं?",
    fieldChannelName: "चैनल का नाम (English)",
    fieldGujaratiName: "स्थानीय नाम",
    fieldCategory: "श्रेणी",
    fieldLanguage: "प्रसारण भाषा",
    fieldStreamUrl: "HLS स्ट्रीम URL (.m3u8)",
    fieldDescription: "संक्षिप्त विवरण",
    fieldOrder: "प्रदर्शन क्रम",
    fieldStatus: "प्रसारण स्थिति",
    fieldFeatured: "विशेष चैनल के रूप में दिखाएं",
    saveSuccessMsg: "चैनल सफलतापूर्वक सहेजा गया!",
    deleteSuccessMsg: "चैनल सफलतापूर्वक हटा दिया गया!",

    footerDesc: "BHADKO DIGITAL TV MEDIA दुनिया भर के दर्शकों के लिए प्रीमियम गुजराती मनोरंजन, समाचार और लाइव टेलीविज़न प्रदान करता है।",
    footerExplore: "अन्वेषण करें",
    footerSupport: "सहायता",
    helpCenter: "सहायता केंद्र",
    terms: "नियम एवं शर्तें",
    privacy: "गोपनीयता नीति",
    contactUs: "संपर्क करें",
    copyright: "© 2026 BHADKO DIGITAL TV MEDIA. सर्वाधिकार सुरक्षित. powered by Earthin.online/"
  },

  en: {
    brandTitle: "BHADKO OTT",
    brandSubtitle: "BHADKO DIGITAL TV MEDIA",
    navHome: "Home",
    navAllChannels: "All Channels",
    navLiveTV: "Live TV",
    navFavorites: "Favorites",
    navCategories: "Categories",
    navAdmin: "Admin",
    navTvMode: "TV Mode",
    searchPlaceholder: "Search for channels, categories...",
    searchChannelsPlaceholder: "Search channels...",

    allChannelsTitle: "બધા ચેનલ | All Channels",
    allChannelsSubtitle: "Browse through 50+ live television channels across multiple languages.",
    allLanguages: "All Languages",
    sortLatest: "Latest",
    sortPopular: "Most Watched",
    sortAlphabetical: "Alphabetical (A-Z)",
    watchLive: "Watch Live",
    startingSoon: "STARTING SOON",
    offline: "OFFLINE",
    liveBadge: "LIVE",
    loadMore: "Load More Channels",
    noChannelsFound: "No Channels Found",
    noChannelsSubtitle: "Try searching with different keywords or clearing your filters.",
    resetFilters: "Reset Filters",

    watchingCount: "Watching",
    verified: "VERIFIED",
    share: "Share",
    shareSuccess: "Channel stream link copied to clipboard!",
    addToFavorites: "Add to Favorites",
    removeFromFavorites: "Favorited",
    tabAbout: "About",
    tabSchedule: "Program Schedule",
    tabRelated: "Related Channels",
    nowPlaying: "Now Playing",
    upcoming: "Upcoming Program",
    studio: "Broadcast Studio",
    network: "Network",
    resolution: "Resolution",
    bitrate: "Bitrate",
    audio: "Audio Track",
    editorialChief: "Editor in Chief",
    streamUnavailable: "Stream Unavailable",
    streamUnavailableDesc: "The live broadcast feed is currently resting or reconnecting. Automatic recovery active.",
    loadingStream: "Connecting to Live Stream...",
    retryButton: "Try Again",
    channelSidebarTitle: "All Channels",
    filterBtn: "Filter",
    switchChannelPrompt: "Click to switch channel",
    qualityAuto: "Auto (1080p)",

    favoritesTitle: "Your Favorite Channels",
    favoritesSubtitle: "Quick access to your curated live stream collection.",
    noFavoritesTitle: "No Favorite Channels Yet",
    noFavoritesDesc: "Click the star icon (★) on any channel card or player to save it to your favorites.",
    browseChannelsBtn: "Explore All Channels",

    tvModeActive: "Smart TV Navigation Active",
    tvModeHint: "Use Arrow Keys (↑ ↓ ← →) on your remote/keyboard to navigate and 'Enter / OK' to select.",
    tvExitHint: "Press Escape or click 'TV Mode' to exit back to standard web mode.",

    adminTitle: "BHADKO OTT - Channel Management Console",
    adminSubtitle: "Create, edit, reorder, preview and configure live streams across the broadcast catalog.",
    btnAddNewChannel: "+ Add New Channel",
    colLogo: "Logo",
    colName: "Channel Name",
    colCategory: "Category",
    colLanguage: "Language",
    colStatus: "Status",
    colStream: "Stream URL",
    colActions: "Actions",
    activeStatus: "Active",
    inactiveStatus: "Inactive",
    btnEdit: "Edit",
    btnDelete: "Delete",
    btnPreview: "Preview",
    btnSave: "Save Channel",
    btnCancel: "Cancel",
    modalAddTitle: "Add New Channel Record",
    modalEditTitle: "Edit Channel Configuration",
    confirmDeleteTitle: "Confirm Channel Deletion",
    confirmDeleteDesc: "Are you sure you want to permanently delete this channel from the catalog?",
    fieldChannelName: "Channel Name (English)",
    fieldGujaratiName: "Gujarati / Regional Name",
    fieldCategory: "Category",
    fieldLanguage: "Broadcast Language",
    fieldStreamUrl: "HLS Stream URL (.m3u8)",
    fieldDescription: "Short Description",
    fieldOrder: "Display Order",
    fieldStatus: "Broadcast Status",
    fieldFeatured: "Mark as Featured Channel",
    saveSuccessMsg: "Channel catalog updated successfully!",
    deleteSuccessMsg: "Channel removed successfully!",

    footerDesc: "BHADKO DIGITAL TV MEDIA provides premium Gujarati entertainment, news, and live television to audiences worldwide. Experience high-quality streaming on any device.",
    footerExplore: "Explore",
    footerSupport: "Support",
    helpCenter: "Help Center",
    terms: "Terms of Service",
    privacy: "Privacy Policy",
    contactUs: "Contact Us",
    copyright: "© 2026 BHADKO DIGITAL TV MEDIA. All rights reserved. powered by Earthin.online/"
  }
};
